// extracted by mini-css-extract-plugin
module.exports = {"DeleteButton":"DeleteButton_DeleteButton__2C7Kk"};